import * as React from 'react';
const MessageSentInitiatedChatIcon = () => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.995 1C3.235 1 1 3.24 1 6C1 8.76 3.235 11 5.995 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 5.995 1ZM6 10C3.79 10 2 8.21 2 6C2 3.79 3.79 2 6 2C8.21 2 10 3.79 10 6C10 8.21 8.21 10 6 10ZM5.89 3.5H5.86C5.66 3.5 5.5 3.66 5.5 3.86V6.22C5.5 6.395 5.59 6.56 5.745 6.65L7.82 7.895C7.99 7.995 8.21 7.945 8.31 7.775C8.415 7.605 8.36 7.38 8.185 7.28L6.25 6.13V3.86C6.25 3.66 6.09 3.5 5.89 3.5Z"
      fill="#969696"
    />
  </svg>
);
export default MessageSentInitiatedChatIcon;
